import { css } from 'office-ui-fabric-react';
import * as React from 'react';

type SectionProps = {
    id?: string;
    isOpen: boolean;
    className: string;
    onExpand?: () => void;
    onCollapse?: () => void;
    onRenderHeader?: () => JSX.Element;
    onRenderBody: () => JSX.Element;
    onKeyDown?: React.KeyboardEventHandler<any>;
}

export type AccordionSectionRef = {
    expand: () => void;
    collapse: () => void;
    getRef: () => HTMLDivElement | null;
}

const AccordionSection = React.forwardRef<AccordionSectionRef, SectionProps>((props, ref) => {    
    React.useImperativeHandle(ref, () => ({
        expand() { props.onExpand?.() },
        collapse() { props.onCollapse?.() },
        getRef(): HTMLDivElement | null { return divRef.current }
    }));

    const divRef = React.useRef<HTMLDivElement>(null);
    return (
        <div id={props.id} ref={divRef} className={css(props.className, props.isOpen && "open")} onKeyDown={props.onKeyDown} aria-hidden >
            {props.onRenderHeader && <div className="section-head">
                {props.onRenderHeader()}
            </div>}
            {props.isOpen &&
                <div className="section-body">
                    <div className="section-body-container">
                        {props.onRenderBody()}
                    </div>
                </div>
            }
        </div>
    );
});
export default AccordionSection;